//import Components
import {Nav, NavItem} from "reactstrap";

import {NavLink} from "react-router-dom";
import {pageLinks} from "../../../App";



export default function SideNav () {
    return (
        <>
            <span className={"sideNav-heading"}>Meny</span>
            <Nav as={"ul"}>
                {pageLinks.map((page, i) => {
                    if (page.displayInSideNav) {
                        return (
                            <NavItem className={"sideNav_item"} as={"li"} key={i}>
                                <NavLink title={page.page} className={"sideNav-item nav-link"} to={page.link}>
                                    <span className={"nav-icon"}>{page.icon}</span> <span className={"nav-label"}>{page.page}</span>
                                </NavLink>
                            </NavItem>
                        );
                    }
                })}
            </Nav>
        </>
    )
}
